import { FC, Dispatch } from "react";

interface viewerOptionDialogProps {
  imageSource: string;
  buttonSize?: string;
  buttonAccent?: string;
  alternativeText: string;
  dispatch: Dispatch<any>;
}

const MenuButton: FC<viewerOptionDialogProps> = ({
  imageSource,
  buttonSize,
  buttonAccent,
  alternativeText,
  dispatch,
}) => {
  // "primary" tints the row the type's main action lives on, "destructive"
  // sets delete apart below a divider; neither is inferred from position,
  // since role-gated rows come and go
  const accentClass =
    buttonAccent === "primary"
      ? " menuButtonPrimary"
      : buttonAccent === "destructive"
      ? " menuButtonDestructive"
      : "";

  // the rail shows icons only, so hovering names the button; rail labels are
  // all caps, so they are put in sentence case to read like the viewer
  // toolbar's tips ("Fit to model"); panel labels are already written that way
  const hoverTitle =
    alternativeText === alternativeText.toUpperCase()
      ? alternativeText.charAt(0) + alternativeText.slice(1).toLowerCase()
      : alternativeText;

  return (
    <>
      <div
        className={`menuButton${accentClass}`}
        title={hoverTitle}
        onClick={dispatch}
      >
        <img
          className={buttonSize === "small" ? "icon-small" : "icon-big"}
          src={imageSource}
          draggable="false"
          alt={alternativeText}
        />
        <span className="menuButtonLabel">{alternativeText}</span>
      </div>
    </>
  );
};

export default MenuButton;
